export const messages = {
  en: {
    serviceProvideManage: {
      queryCondition: 'Query Conditions',
      inputServiceCode: 'Please enter service code',
      inputServiceName: 'Please enter service name',
      selectImplementMethod: 'Please select implementation method',
      storedProcedure: 'Stored procedure',
      query: 'Query',
      reset: 'Reset',
      serviceProvideInfo: 'Service Provide Information',
      provideId: 'Provide ID',
      serviceName: 'Service Name',
      serviceCode: 'Service Code',
      params: 'Parameters',
      implementMethod: 'Implementation Method',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    editServiceProvide: {
      editServiceProvide: 'Edit Service Provide',
      serviceName: 'Service Name',
      inputServiceName: 'Required, please enter service name',
      serviceCode: 'Service Code',
      inputServiceCode: 'Required, please enter service code',
      params: 'Parameters',
      inputParams: 'Required, please enter parameters',
      implementMethod: 'Implementation Method',
      selectImplementMethod: 'Required, please select implementation method',
      outputTemplate: 'Output Template',
      inputTemplate: 'Optional, please enter template',
      inputSql: 'Optional, please enter SQL',
      inputStoredProcedure: 'Optional, please enter stored procedure',
      inputJava: 'Optional, please enter Java',
      description: 'Description',
      inputDescription: 'Optional, please enter description',
      save: 'Save',
      cancel: 'Cancel',
      closeConfirm: 'Are you sure to close? Unsaved changes will be lost',
      updateSuccess: 'Update successfully',
      storedProcedure: 'Stored procedure',
      serviceNameRequired: 'Service name is required',
      serviceCodeRequired: 'Service code is required',
      paramsRequired: 'Parameters are required',
      implementMethodRequired: 'Implementation method is required'
    },
    deleteServiceProvide: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteServiceProvide: 'Confirm to delete service provide',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    serviceProvideManage: {
      queryCondition: '查询条件',
      inputServiceCode: '请输入服务编码',
      inputServiceName: '请输入服务名称',
      selectImplementMethod: '请选择实现方式',
      storedProcedure: '存储过程方式',
      query: '查询',
      reset: '重置',
      serviceProvideInfo: '服务提供信息',
      provideId: '提供ID',
      serviceName: '服务名称',
      serviceCode: '服务编码',
      params: '参数',
      implementMethod: '实现方式',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    editServiceProvide: {
      editServiceProvide: '修改服务提供',
      serviceName: '服务名称',
      inputServiceName: '必填，请填写服务名称',
      serviceCode: '服务编码',
      inputServiceCode: '必填，请填写服务编码',
      params: '参数',
      inputParams: '必填，请填写参数',
      implementMethod: '实现方式',
      selectImplementMethod: '必填，请选择实现方式',
      outputTemplate: '输出模板',
      inputTemplate: '选填，请填写输出模板',
      inputSql: '选填，请填写sql',
      inputStoredProcedure: '选填，请填写存储过程',
      inputJava: '选填，请填写java',
      description: '描述',
      inputDescription: '选填，请填写描述',
      save: '保存',
      cancel: '取消',
      closeConfirm: '确认关闭吗？未保存的修改将会丢失',
      updateSuccess: '修改成功',
      storedProcedure: '存储过程方式',
      serviceNameRequired: '服务名称不能为空',
      serviceCodeRequired: '服务编码不能为空',
      paramsRequired: '参数不能为空',
      implementMethodRequired: '实现方式不能为空'
    },
    deleteServiceProvide: {
      confirmOperation: '请确认您的操作',
      confirmDeleteServiceProvide: '确定删除服务提供',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}